import { type User } from '@autone/auth';

export const useIntercom = (intercomAppId: string | undefined, user: User) => {
  const handleIntercomBoot = () => {
    if (intercomAppId) {
      // @ts-ignore TODO fix this type
      window.Intercom('boot', {
        app_id: intercomAppId,
        name: user.name,
        email: user.email,
        user_id: user.userId,
        hide_default_launcher: true, // Hide the default chat bubble
      });
    }
  };

  return { handleIntercomBoot };
};
